import { INITIAL_STATE } from 'redux/reducers/settingsReducer'
import * as REDUX_TYPES from '../types'

const MIN_OPACITY = 0
const MAX_OPACITY = 0.5
const OPACITY_INCREMENT = 0.1

export const getStorageSettings = () => {
  const settings = localStorage.getItem(REDUX_TYPES.SETTINGS.SET)
  if (settings) {
    return JSON.parse(settings)
  }
  return INITIAL_STATE
}

export const incrementControlColumnOpacity = (opacity) => {
  let target
  if (opacity + OPACITY_INCREMENT > MAX_OPACITY) {
    target = MIN_OPACITY
  } else {
    target = opacity + OPACITY_INCREMENT
  }
  return {
    type: REDUX_TYPES.SETTINGS.CONTROL_COLUMN_OPACITY,
    controlColumnOpacity: target,
  }
}

/**
 * Get the localStorage settings and return it as a {type,settings} dispatch action
 * @returns
 */
export const reloadReduxSettings = () => {
  const settings = getStorageSettings()
  return setSettings(settings)
}

export const storeSettings = (settings) => {
  localStorage.setItem(REDUX_TYPES.SETTINGS.SET, JSON.stringify(settings))
}

export const setSettingsCurrency = (currency) => {
  storeSettings({ ...getStorageSettings(), currency })
  return {
    type: REDUX_TYPES.SETTINGS.CURRENCY,
    currency,
  }
}

export const setSettings = (settings) => {
  return {
    type: REDUX_TYPES.SETTINGS.SET,
    settings,
  }
}
export const setShowEthInCurrency = (showEthInCurrency) => {
  storeSettings({ ...getStorageSettings(), showEthInCurrency })
  return {
    type: REDUX_TYPES.SETTINGS.SHOW_ETH_IN_CURRENCY,
    showEthInCurrency,
  }
}

export const setShowMintingDefaults = (showMintingDefaults) => {
  storeSettings({ ...getStorageSettings(), showMintingDefaults })
  return {
    type: REDUX_TYPES.SETTINGS.SHOW_MINTING_DEFAULTS,
    showMintingDefaults,
  }
}
